<template>
  <div class="mt-15 container card_container" v-if="jsonData.stepNre === 0">
    <b-container class="bv-example-row">
      <div class="mb-5">
        <modal></modal>
        <h3 class="mt-5 mb-5 titolo"><i class="fas fa-laptop-medical"></i> Prenotazione con ricetta elettronica</h3>
        <!--<b-button v-b-modal.modal-1 class="btn-outline"><i class="fa fa-info-circle"></i> Informazioni</b-button>-->
      </div>
      <b-row>
        <b-col sm class="mb-7 mt-5">
          <div class="h-35px">
            <strong class="text-primary">Assistito</strong>
          </div>
          <!-- <b-form-select
            class="form-select"
            v-model="jsonData.assistito"
            :options="assistitoOptions"
            :value="null"
            value-field="value"
            text-field="text"
            @change="getSelectedAssistito"
          ></b-form-select> -->
          <span>{{ jsonData.assistito.nome }} {{ jsonData.assistito.cognome }} - {{
              jsonData.assistito.codiceFiscale
            }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm class="mb-7 mt-5">
          <div class="h-35px">
            <strong class="text-primary">Primo codice impegnativa</strong>
          </div>
          <b-form-input
              type="text"
              class="form-control form-control-solid"
              name="input1"
              placeholder=""
              value=""
              style="text-transform: uppercase"
              maxlength="5"
              v-model="primoCodiceImpegnativa"
              required
              :state="validationPrimoCodice"
              v-on:keyup.enter="onInviaDati"
          />
        </b-col>
        <b-col sm class="mb-7 mt-5">
          <div class="h-35px">
            <strong class="text-primary">Secondo codice impegnativa</strong>
          </div>
          <b-input-group>
            <b-form-input
                type="text"
                class="form-control form-control-solid"
                name="input1"
                placeholder=""
                value=""
                style="text-transform: uppercase"
                maxlength="10"
                v-model="secondoCodiceImpegnativa"
                required
                :state="validationSecondoCodice"
                v-on:keyup.enter="onInviaDati"
            />
            <b-input-group-append>
              <b-button v-b-modal.modal-1 class="btn-outline ml-3"><i class="fa fa-info-circle"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
        <a>
          <b-button class="my-5 btn-outline" @click="onInviaDati" :disabled="abilitaPresaInCarico"><i
              class="fas fa-file-medical"></i> Invia dati
          </b-button>
        </a>
      </div>
        <div>
            <b-alert show variant="warning">
                <h4 class="alert-heading">Attenzione!</h4>
                <p>
                    {{ infoPrenotazioniNonDisponibili }}
                </p>
            </b-alert>
        </div>
    </b-container>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots"
             :height="120" :width="120"></loading>
  </div>
  <riepilogo-nre
      v-else-if="jsonData.stepNre === 1"
      :assistito="jsonData.assistito"
      :presaInCarico="jsonData.presaInCarico"
      @getPrimaDisponibilita="getPrimaDisponibilita"
      @setStep="setStep"
  ></riepilogo-nre>
  <controllo-disponibilita-nre
      v-else-if="jsonData.stepNre === 2"
      :assistito="jsonData.assistito"
      :presaInCarico="jsonData.presaInCarico"
      :esamiDisponibili="jsonData.primaDisponibilita"
      :responsePrimaDisponibilita="responsePrimaDisponibilita"
      @setStep="setStep"
      @setEsamiDisponibili="setEsamiDisponibili"
      @onSedeSelezionata="onSedeSelezionata"
      @setListaSedi="setListaSedi"
      :listaSedi="listaSedi"
  ></controllo-disponibilita-nre>
  <disponibilita-nre
      v-else-if="jsonData.stepNre === 3"
      :assistito="jsonData.assistito"
      :presaInCarico="jsonData.presaInCarico"
      :esamiDisponibili="jsonData.primaDisponibilita"
      :sedeSelezionata="sedeSelezionata"
      :listaSedi="listaSedi"
      @setStep="setStep"
  ></disponibilita-nre>
</template>
<script>
import modal from "../modal/modalInfoNre.vue";
import strutture from "../../classes/strutture";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import UtilityMixin from "../../utilities/utilityMixin";
import RiepilogoNre from "./riepilogoNre.vue";
import DisponibilitaNre from "./disponibilitaNre.vue";
import ControlloDisponibilitaNre from "./controlloDisponibilitaNre.vue";
import AuthService from "@/services/authService";
import EngiService from "@/services/engiService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  //Step 0 presaInCarico, Step 1 riepilogoNre, Step 2 disponibilitaNre
  mixins: [UtilityMixin],
  components: {
    modal,
    Loading,
    RiepilogoNre,
    DisponibilitaNre,
    ControlloDisponibilitaNre,
  },
  data() {
    return {
        infoPrenotazioniNonDisponibili:" Si informa che al momento non è possibile prenotare tramite Portale le prestazioni afferenti al Lab. Analisi e Centro Trasfusionale",
      pathResorceInfoUtente: "/api/v2.0/appecupt/auth/prelevaAnagraficaUtente",
      pathResourceConferma: "/api/v2.0/appecupt/aslengi/ricetta",
      jsonData: {
        assistito: {},
        nre: "",
        presaInCarico: {},
        stepNre: 0,
        primaDisponibilita: [],
      },
      responsePrimaDisponibilita: {},
      primoCodiceImpegnativa: "1400A",
      secondoCodiceImpegnativa: "",
      assistitoOptions: [{value: null, text: "Seleziona Assistito"}],
      token: null,
      tokenLogin: null,
      listaStrutture: strutture,
      isLoading: false,
      sedeSelezionata: null,
      listaSedi: [],
    };
  },
  computed: {
    struttura() {
      return this.$route.params.struttura;
    },
    validationPrimoCodice() {
      return this.primoCodiceImpegnativa.length === 0 ? null : this.primoCodiceImpegnativa.length === 5 ? true : false;
    },
    validationSecondoCodice() {
      return this.secondoCodiceImpegnativa.length === 0 ? null : this.secondoCodiceImpegnativa.length === 10 ? true : false;
    },
    abilitaPresaInCarico() {
      return !(this.primoCodiceImpegnativa.length === 5 && this.secondoCodiceImpegnativa.length === 10 && this.jsonData.assistito != null);
    },
  },
  mounted: function () {
    let me = this;
    me.token = sessionStorage.getItem("tokenWSO2");
    me.tokenLogin = sessionStorage.getItem("loginData");
    me.secondoCodiceImpegnativa = "";

      let msg = getVocabolario("infoPrenotazioniNonDisponibili")
      if(msg){
        this.infoPrenotazioniNonDisponibili = msg;
      }
    me.loadInfoUtente();
  },
  methods: {
    async loadInfoUtente() {
      let me = this;
      try {
        const responseInfoUtente = await AuthService.anagraficaUtente(me.tokenLogin);
        me.jsonData.assistito = responseInfoUtente.data.data;
        me.$emit("getInfoUtente", me.jsonData.assistito);
      } catch (error) {
        me.$bvModal
            .msgBoxOk(error, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
            })
            .catch(() => {
            });
      }
    },
    getSelectedAssistito(assistito) {
      let me = this;
      me.jsonData.assistito = assistito;
    },
    async onInviaDati() {
      let me = this;
      if (me.abilitaPresaInCarico) {

          let msg = getVocabolario("selezionaAssistitoPrenotazione")
          if(!msg)
              msg = "Seleziona l'assistito per cui vuoi prenotare e i codici impegnativa."
        return this.$bvModal
            .msgBoxOk(msg, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
            })
            .catch(() => {
            });
      }
      me.isLoading = true;
      try {
        const responseRicetta = await EngiService.ricetta(me.jsonData);
          console.log(responseRicetta)
        if (responseRicetta.data.stato === 200) {
          me.jsonData.presaInCarico = responseRicetta.data.data;
          me.setStep(1);
        } else {
          this.$bvModal
              .msgBoxOk(responseRicetta.data.errore, {
                title: "Errore",
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
              })
              .catch(() => {
              });
          me.isLoading = false;
        }
      } catch (error) {
        me.isLoading = false;
        this.$bvModal.msgBoxOk(error, {
          title: "Errore",
          size: "sm",
          okVariant: "outline-danger",
          headerClass: "vv-msg-header-danger",
          footerClass: "p-2 border-top-0",
          centered: true,
        });
      }
    },
    setStep(step) {
      let me = this;
      me.jsonData.stepNre = step;
      me.isLoading = false;
    },
    setEsamiDisponibili(esamiConSede) {
      let me = this;
      console.log(esamiConSede);
      me.jsonData.primaDisponibilita = esamiConSede;
    },
    getPrimaDisponibilita(primaDisponibilita) {
      let me = this;
      me.jsonData.primaDisponibilita = primaDisponibilita.data;
      me.responsePrimaDisponibilita = primaDisponibilita;
    },
    getProssimaDisponibilita(prossimaDisponibilita) {
      let me = this;
      me.jsonData.prossimaDisponibilita = prossimaDisponibilita;
    },
    onSedeSelezionata(sedeSelezionata) {
      let me = this;
      me.sedeSelezionata = sedeSelezionata;
    },
    setListaSedi(listaSedi) {
      let me = this;
      me.listaSedi = listaSedi;
    },
  },
  watch: {
    primoCodiceImpegnativa: function (value) {
      this.jsonData.nre = `${value}${this.secondoCodiceImpegnativa}`.toUpperCase();
    },
    secondoCodiceImpegnativa: function (value) {
      this.jsonData.nre = `${this.primoCodiceImpegnativa}${value}`.toUpperCase();
    },
  },
};
</script>

<style>
a:hover {
  text-decoration: none;
  color: #fff;
}
</style>
